import { toast } from 'react-toastify';

const notifySuccess = (text: string): any => toast.success(text);
const notifyError = (text: string): any => toast.error(text);
const notifyInfo = (text: string): any => toast.info(text);

export { notifySuccess, notifyError, notifyInfo }
